import React from 'react';
import { Table } from 'react-bootstrap';
import '../styles/StickyActionsTable.css';

const StickyActionsTable = ({
  columns = [],
  data = [],
  actionsRenderer,
  expandedRowRenderer,
  getRowKey,
  noDataMessage = "No records found",
  tableClassName = "",
}) => {
  const wrapperRef = React.useRef(null);
  const totalColumns = columns.length + (actionsRenderer ? 1 : 0);

  React.useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return undefined;

    const updateExpandedWidth = () => {
      wrapper.style.setProperty(
        '--sticky-actions-viewport-width',
        `${wrapper.clientWidth}px`
      );
    };

    updateExpandedWidth();

    let observer;
    if (typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(updateExpandedWidth);
      observer.observe(wrapper);
    }

    window.addEventListener('resize', updateExpandedWidth);

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener('resize', updateExpandedWidth);
    };
  }, []);

  return (
    <div
      ref={wrapperRef}
      className={`sticky-actions-table-wrapper ${tableClassName}`}
    >
      <Table responsive>
        <thead>
          <tr>
            {columns.map((col, index) => (
              <th
                key={index}
                style={{
                  textAlign: col.align || 'left',
                  whiteSpace: 'nowrap',
                  ...(col.style || {})
                }}
              >
                {col.header}
              </th>
            ))}
            {actionsRenderer && (
              <th className="sticky-actions-header">
                Actions
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {data.length ? (
            data.map((row, rowIndex) => {
              const rowKey = getRowKey
                ? getRowKey(row, rowIndex)
                : row.id || rowIndex;
              const expandedContent = expandedRowRenderer
                ? expandedRowRenderer(row, rowIndex)
                : null;

              return (
                <React.Fragment key={rowKey}>
                  <tr>
                    {columns.map((col, colIndex) => (
                      <td
                        key={colIndex}
                        style={{
                          textAlign: col.align || 'left',
                          whiteSpace: 'nowrap',
                          ...(col.style || {})
                        }}
                      >
                        {col.render ? col.render(row, rowIndex) : (row[col.accessor] || "--")}
                      </td>
                    ))}
                    {actionsRenderer && (
                      <td className="sticky-actions-cell">
                        {actionsRenderer(row, rowIndex)}
                      </td>
                    )}
                  </tr>
                  {expandedContent && (
                    <tr className="sticky-actions-expanded-row">
                      <td
                        colSpan={totalColumns}
                        className="sticky-actions-expanded-cell"
                      >
                        <div className="sticky-actions-expanded-content">
                          {expandedContent}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })
          ) : (
            <tr>
              <td colSpan={totalColumns} className="text-center py-4">
                {noDataMessage}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default StickyActionsTable;
